'use strict';

var _regeneratorRuntime = require("/home/jenkins/workspace/buch-editor-frontend_master-HFHSIVOQ6IJI5ZBPHCHU7A6EKU7FAGJSAKF6XQUXPUJGATAUMFRQ/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee2;

var _dependecies = require('../../dependecies');

var _actions = require('../actions');

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee2);

var select = _dependecies.sagaEffects.select,
    put = _dependecies.sagaEffects.put,
    takeEvery = _dependecies.sagaEffects.takeEvery;

function _callee2() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _dependecies.routingSelector;
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(_dependecies.LOCATION_CHANGE,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var location;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return select(selector);

                  case 2:
                    location = _context.sent;
                    _context.next = 5;
                    return put((0, _actions.addLocation)(location));

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked, this);
}